const RECOVERY_COOLDOWN_MS = 60_000;

interface SnapshotRecovery {
  tryRefresh: (loading: boolean, onRefresh: (() => void) | undefined, now?: number) => boolean;
}

export const createTabularSnapshotRecovery = (): SnapshotRecovery => {
  let lastAttempt: number | undefined;
  return {
    tryRefresh: (loading, onRefresh, now = Date.now()) => {
      if (!onRefresh) {
        return false;
      }
      if (loading) {
        return true;
      }
      if (lastAttempt !== undefined && now - lastAttempt < RECOVERY_COOLDOWN_MS) {
        return false;
      }
      // The guard survives replacement results so a broken replacement cannot cause a refresh loop.
      lastAttempt = now;
      onRefresh();
      return true;
    },
  };
};
